import React, { useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Box,
  // Button,
  Container,
  Typography,
  makeStyles,
  Card
} from '@material-ui/core';

import { useAuthContext } from 'src/context/AuthContext';
import Page from 'src/components/Page';
import { FirebaseAuth } from 'src/components/Auth/Firebase';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3)
  }
}));

const LoginView = () => {
  const classes = useStyles();
  const {user, logout} = useAuthContext();

  const navigate = useNavigate();
  useEffect(()=>{
    if(user){
      // navigate('/app/harvesting');
    }
  },[user]);

  return (
    <Page
      className={classes.root}
      title="Login"
    >

      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Card className={classes.paper}>
            <Box mb={3}>
              <Typography
                color="textPrimary"
                variant="h2"
              >
                Sign in
              </Typography>
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
              >
                Sign in on the fishing platform
              </Typography>
            </Box>
            {user ?
              (
                <div className="dropdown">
                  <p>{`Welcome, ${user.displayName}`}</p>
                  <div className="dropdown-content">
                    <Link to="/">Create Stories</Link>
                    <Link to="/">My Stories</Link>
                    <Link to="/login" onClick={() => logout()}>Sign Out</Link>
                  </div>
                </div>
              ) :
              (
                <FirebaseAuth />
              )
            }

          </Card>
        </Container>
      </Box>
    </Page>
  );
};

export default LoginView;